import { Model } from '@vuex-orm/core'
import axios from 'axios'
import { getCachedResponse, cacheResponse } from '../utils/storageCache'

async function getSharedUsers(token, specialties) {
  const url = `/users?specialty=${specialties.join(',')}&thumbnails=true`

  const cachedResponse = await getCachedResponse(url)

  if (cachedResponse) {
    return cachedResponse
  }

  const result = await axios.get(url, {
    headers: {
      Authorization: `Bearer ${token}`
    }
  })

  cacheResponse(url, result.data, 60 * 60 * 24 * 5)

  return result.data
}

export class SharedUsers extends Model {
  static entity = 'sharedUsers'
  static primaryKey = 'id'

  static fields() {
    return {
      id: this.string(),
      firstName: this.string(),
      lastName: this.string(),
      specialty: this.string(),
      hospital: this.string(),
      license: this.string()
    }
  }

  static async fetch(token, specialties, force = false) {
    const users = SharedUsers.query().get()
    if (users.length === 0 || force === true) {
      const newUsers = await getSharedUsers(token, specialties)

      this.insert({ data: newUsers })
    }
  }
}
